export enum TypeOrgan {
  ANEEL = 'ANEEL',
  MME = 'MME',
  ANA = 'ANA',
  ONS = 'ONS',
  EPE = 'EPE'
}
